import auth0 from 'auth0-js';

import { EMAIL_PASSWORD_CONNECTION_NAME } from '../core/constants'
import { showErrorNotification, showInlineNotification } from './notifications';
import { translate } from '~/services/translate';

const AUTH_MODES = {
  SIGN_UP: 'signUp',
  LOG_IN: 'login',
};

let webAuth;
let config = {};

export const getReferrer = () => config.referrer || null;

export const isSignUp = () => Boolean(config.mode === AUTH_MODES.SIGN_UP && config.isVpaaS);

export const isPaid = () => config.isPaid;

export const isVpaaS = () => config.isVpaaS;

export const vpaasMode = () => config.vpaasMode;

export const appName = () => config.isVpaaS ? 'vpaas' : 'standalone';

export const prefillEmail = () => config.prefillEmail ? decodeURIComponent(config.prefillEmail) : undefined;

export const init = (params, cfg) => {
  config = cfg;
  setDocumentTitle(config.mode === AUTH_MODES.SIGN_UP);
  webAuth = new auth0.WebAuth(params);
}

export const setDocumentTitle = signUp => {
  if (signUp) {
    document.title = translate('sign_up_auth');
  } else {
    document.title = translate('sign_in_auth');
  }
}

export const toggleAuthMode = () => {
  if (config.mode === AUTH_MODES.SIGN_UP) {
    config.mode = AUTH_MODES.LOG_IN;
  } else {
    config.mode = AUTH_MODES.SIGN_UP;
  }

  return config.mode;
}

const continueWithUserPassword = (email, password, fullName, optIn) => new Promise(resolve => {
  if (!webAuth) {
    resolve();
    return;
  }

  if (isSignUp()) {
    const options = {
      connection: EMAIL_PASSWORD_CONNECTION_NAME,
      email,
      password,
      optIn,
    }

    if (fullName && fullName.trim()) {
      options.name = fullName.trim();
    }

    webAuth.redirect.signupAndLogin(options, err => {
      if (err) {
        if (err.statusCode === 400 && err.code === 'invalid_signup') {
          showErrorNotification(translate('account_already_exists'));
        } else {
          showErrorNotification(translate('failed_signing_up'));
        }
      }
      resolve();
    });
  } else {
    webAuth.login({
      connection: EMAIL_PASSWORD_CONNECTION_NAME,
      realm: EMAIL_PASSWORD_CONNECTION_NAME,
      email,
      password,
    }, err => {
      if (err) {
        const notif = `${translate('failed_logging_in')}
          ${err.description ? `: ${err.description}` : ``}`;
        showErrorNotification(notif);
      }
      resolve();
    });
  }
});

const resetPassword = email => new Promise(resolve => {
  if (!webAuth) {
    resolve();
    return;
  }

  webAuth.changePassword({
    connection: EMAIL_PASSWORD_CONNECTION_NAME,
    email,
  }, err => {
    if (err) {
      showErrorNotification(translate('failed_reset_password'));
    } else {
      showInlineNotification(translate('reset_password_notification'));
    }

    resolve();
  });
})

const continueWithSocial = connection => new Promise(resolve => {
  if (!webAuth) {
    resolve();
    return;
  }

  webAuth.authorize({
    connection,
  }, err => {
    if (err) {
      showErrorNotification(isSignUp() ?
        translate('failed_signing_up') :
        translate('failed_logging_in')
      );
    }

    resolve();
  });
})

export default {
  continueWithSocial,
  continueWithUserPassword,
  resetPassword,
}